import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import styles from './PasswordInput.css';
import Input from '../Input';
import appStyles from '../../../styles/app.css';

const PasswordInput = ({
    className,
    hidden,
    toggleHidden,
    color,
    ...props
}) => (<Input
    className={cx(styles.input, className)}
    type={hidden ? 'password' : 'text'}
    {...props}
>
    <button
        className={styles.button}
        style={{ color }}
        onClick={() => toggleHidden(!hidden)}
        type="button"
    >
        <span>
            {hidden ? 'Show ' : 'Hide '}
            <span className={appStyles.hidden}>password</span>
        </span>
    </button>
</Input>);

PasswordInput.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    hidden: PropTypes.bool,
    toggleHidden: PropTypes.func,
};

const hidden = ({ defaultHidden }) => (
    typeof defaultHidden === 'undefined' ? true : defaultHidden
);

export default compose(
    connect(({ theme }) => ({
        color: theme.primaryColor,
    })),
    withState('hidden', 'toggleHidden', hidden),
)(PasswordInput);



// WEBPACK FOOTER //
// ./src/client/Components/Forms/PasswordInput/PasswordInput.js